import { render, staticRenderFns } from "./TypeOccurrenceStatusForm.vue?vue&type=template&id=3a9b14a2&"
import script from "./TypeOccurrenceStatusForm.vue?vue&type=script&lang=js&"
export * from "./TypeOccurrenceStatusForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports